<form class="itinerary-model-content-inner"  [formGroup]="brandDetailsForm" *ngIf="brandDetailsForm">
  <div class="itinerary-model-content">
    <div class="form-container">
      <!-- Users Details start -->
      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Brand Details</ion-title>
      </div>

      <div class="form-container ion-padding-horizontal">
        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Company Logo</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('imageFile')?.invalid && brandDetailsForm.get('imageFile')?.touched }">
                <div class="file-view" *ngIf="brandDetailsForm.get('imageFile')?.value">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="clickable-text mb-0" style="font-size: 14px; font-weight: 600;" (click)="openAttachment(brandDetailsForm.get('imageFile')?.value)">View Uploaded Image</p>
                    <div class="d-flex">
                      <label for="organizationImageInput" class="unfilled-gray-btn px-2 my-1">
                        Reupload
                      </label>
                      <ion-button class="unfilled-red-btn" (click)="deleteOrganizationImage()">Delete</ion-button>
                    </div>
                  </div>
                </div>
                <div [ngClass]="{'d-none' : brandDetailsForm.get('imageFile')?.value}">
                  <input type="file" id="organizationImageInput" class="input" accept="image/*" (change)="onOrganizationLogoSelected($event)">
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Primary Color</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('primaryColor')?.invalid && brandDetailsForm.get('primaryColor')?.touched }">
                <input class="input" type="color" formControlName="primaryColor">
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Secondary Color</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('secondaryColor')?.invalid && brandDetailsForm.get('secondaryColor')?.touched }">
                <input class="input" type="color" formControlName="secondaryColor">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Emergency Phone Number 1</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('enquiryNumber1')?.invalid && brandDetailsForm.get('enquiryNumber1')?.touched }">
                <app-phone-country-input formControlName="enquiryNumber1"></app-phone-country-input>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Emergency Phone Number 2</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('enquiryNumber2')?.invalid && brandDetailsForm.get('enquiryNumber2')?.touched }">
                <app-phone-country-input formControlName="enquiryNumber2"></app-phone-country-input>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Instagram Handle</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('instagramLink')?.invalid && brandDetailsForm.get('instagramLink')?.touched }">
                <input class="input" type="text" placeholder="Instagram Handle" formControlName="instagramLink">
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Facebook Handle</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('facebookLink')?.invalid && brandDetailsForm.get('facebookLink')?.touched }">
                <input class="input" type="text" placeholder="Facebook Handle" formControlName="facebookLink">
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Google Review 1</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('review1')?.invalid && brandDetailsForm.get('review1')?.touched }">
                <textarea class="input" type="text" placeholder="Enter google review here" formControlName="review1" [appMaxLength]="300"></textarea>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="input-container">
              <label for="" class="label">Google Review 2</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('review2')?.invalid && brandDetailsForm.get('review2')?.touched }">
                <textarea class="input" type="text" placeholder="Enter google review here" formControlName="review2" [appMaxLength]="300"></textarea>
              </div>
            </div>
          </div>

          <div class="col-2">
            <div class="input-container">
              <label for="" class="label">Google Rating</label>
              <div [ngClass]="{ 'invalid-input': brandDetailsForm.get('rating')?.invalid && brandDetailsForm.get('rating')?.touched }">
                <input class="input" type="text" placeholder="Ex - 4.9" formControlName="rating" [appMaxLength]="5">
              </div>
            </div>
          </div>
        </div>

        <div class="row my-2">
          <div class="col-6">
            <div class="input-container d-flex gap-2 align-items-center">
              <label for="" class="label mb-0">Show Manually Entered Reveiws in Quote</label>
              <div>
                <ion-toggle formControlName="showManualReviews"></ion-toggle>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="input-container d-flex gap-2 align-items-center">
              <label for="" class="label mb-0">Show/Hide Reviews Section in Quote</label>
              <div>
                <ion-toggle formControlName="showReviewsInTemplate"></ion-toggle>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Users details end -->

    </div>
    

  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>


